module.exports = __webpack_public_path__ + "static/img/cop_sch_logo13.f707ce7d.png";